import { takeLatest, takeEvery } from 'redux-saga/effects';
import _ from 'lodash';

import {
  fetchTaskProfilesRoutine,
  fetchTaskProfileRoutine,
  saveTaskProfileRoutine,
  removeTaskProfileRoutine
} from '../routines';
import { fetchSaga, removeSaga, saveSaga } from './helper';
import { getAccountPath } from '../../utils/firebase';
import { put, post } from '../../utils/request';

function* watchFetchTaskProfilesSaga() {
  yield takeLatest(fetchTaskProfilesRoutine.TRIGGER, fetchSaga(fetchTaskProfilesRoutine, () => getAccountPath('taskprofiles')));
}

function* watchFetchTaskProfileSaga() {
  yield takeLatest(fetchTaskProfileRoutine.TRIGGER, fetchSaga(
    fetchTaskProfileRoutine, (payload) => getAccountPath('taskprofiles', payload.id)));
}

function* watchSaveTaskProfileSaga() {
  yield takeEvery(saveTaskProfileRoutine.TRIGGER, saveSaga(saveTaskProfileRoutine,
    (payload) => getAccountPath('taskprofiles', payload.values.get('id')),
    (payload) => payload.values.get('id') ? put : post,
    (payload) => {
      const data = _.assign({}, _.pick(payload.values.toJS(), ['name', 'description', 'itemTypes']));
      return data;
    }));
}

function* watchRemoveTaskProfileSaga() {
  yield takeEvery(removeTaskProfileRoutine.TRIGGER, removeSaga(removeTaskProfileRoutine,
    (taskProfile) => getAccountPath(`taskprofiles/${taskProfile.id}`)));
}

export {
  watchFetchTaskProfilesSaga,
  watchFetchTaskProfileSaga,
  watchSaveTaskProfileSaga,
  watchRemoveTaskProfileSaga,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/taskprofiles.js